module dg.actions {
    import IQueryAction = dg.domain.queries.IQueryAction;
    import IDomainAction = dg.domain.actions.IDomainAction;
    import ListQueryResult = dg.domain.queries.ListQueryResult;
    import ModelQueryResult = dg.domain.queries.ModelQueryResult;

    export class ActionService {

        public constructor(
            private $filter: ng.IFilterService,
            private $q: ng.IQService,
            private restfullApiClientService: dg.restfulApi.RestfullApiClientService
        ) {
        }


        public getActionFromLink(link: dg.restfulApi.Link, queryParameters?: any) {

            if (link.rel == dg.restfulApi.DG_LINK_RELS.query) {
                return this.getAction(link.href, queryParameters);
            }
            else {
                throw new Error(`Link with rel '${link.rel}' is not from action group.`);
            }
        }

        public getAction(href: string, queryParameters?: any): ng.IPromise<IDomainAction> {
            var deferredQuery = this.$q.defer<IDomainAction>();
            this.restfullApiClientService.get(href, queryParameters).then((result: ng.IHttpResponse<dg.restfulApi.SuccessResult>) => {

                this.restfullApiClientService.mergeActionMetadata(result.data.value).then(mergedAction => {
                    ActionService.adjustPropertyValues(mergedAction);
                    deferredQuery.resolve(mergedAction);
                }, deferredQuery.reject);

            }, deferredQuery.reject);

            return deferredQuery.promise;
        }

        public getQueryResultFromLink(link: dg.restfulApi.Link, queryParameters?: any) {
            if (link.rel == dg.restfulApi.DG_LINK_RELS.queryResult) {
                return this.getQueryResult(link.href, queryParameters);
            }
            else {
                throw new Error(`Link with rel '${link.rel}' is not from query result group.`);
            }
        }

        public getQueryResult(href: string, queryParameters?: any) {
            var deferredResult = this.$q.defer<dg.domain.IDomainObject>();
            this.restfullApiClientService.get(href, queryParameters).then(
                (result: ng.IHttpResponse<dg.restfulApi.SuccessResult>) => {
                    this.mergeMetadata(result).then(deferredResult.resolve, deferredResult.reject);
                }, deferredResult.reject);
            return deferredResult.promise;
        }

        public createChildQueryResult(childArray: dg.domain.IDomainObject[], propMeta: dg.restfulApi.DomainObjectPropertyMetadata) {
            let dgMeta: any;
            if (childArray.length > 0) {
                dgMeta = {
                    id: childArray[0].dgMeta.id,
                    links: propMeta.links,
                };
            }

            let result = <ListQueryResult<dg.domain.IDomainObject>>{
                items: childArray,
                totalCount: childArray.length,
                dgMeta: dgMeta
            };

            this.restfullApiClientService.mergeArrayMetadata(result);

            return result;
        }


        public getExternalExport(executionLink: dg.restfulApi.Link, linkQuery: IQueryAction): ng.IPromise<any> {

            let deferred = this.$q.defer<any>();

            this.executeQuery(linkQuery).then(result => {
                deferred.resolve(this.restfullApiClientService.executeExternalDownload(result.url, executionLink.mediaType));
            }, deferred.reject)


            return deferred.promise;
        }

        public getQueryExport(executionLink: dg.restfulApi.Link, query: dg.domain.queries.ListQuery<dg.domain.IDomainObject>): ng.IPromise<any> {

            let deferred = this.$q.defer<any>();
            let queryParams: any;

            if (query) {
               
                let queryClone = <dg.domain.queries.ListQuery<dg.domain.IDomainObject>>dgUtils.ObjectHelperService.mergeDeep({}, query);                //return all records when exporting to excel
                queryClone.pageNumber = null;
                queryClone.pageSize = null;
                queryParams = this.getQueryParams(queryClone);
            }

            deferred.resolve(this.restfullApiClientService.executeExportFromQuery(executionLink, queryParams));

            return deferred.promise;
        }

        public executeQuery(query: IQueryAction): ng.IPromise<any> {
            var deferredResult = this.$q.defer();
            let resultLink = <dg.restfulApi.Link>query.dgMeta.links[query.dgMeta.id + '_invoke'];
            let queryParams = this.getQueryParams(query);
            this.restfullApiClientService.get(resultLink.href, queryParams).then(result => {
                this.mergeMetadata(result).then(deferredResult.resolve, deferredResult.reject);

            }, deferredResult.reject);

            return deferredResult.promise;
        }

        public mergeMetadata(result) {
            let deferredResult = this.$q.defer();

            //if (result.type == dg.restfulApi.ResultValueType.DomainList) {
            if (result.data.type.toString() == "DomainList") {
                this.restfullApiClientService.mergeListQueryResultMetadata(result.data.value)
                    .then(deferredResult.resolve, deferredResult.reject);
            }
            //else if (result.type == dg.restfulApi.ResultValueType.DomainObject) {
            else if (result.data.type.toString() == "DomainObject") {
                this.restfullApiClientService.mergeModelQueryResultMetadata(result.data.value.model)
                    .then(deferredResult.resolve, deferredResult.reject);
            }
            return deferredResult.promise;
        }


        public executeCommand(command: dg.domain.commands.CommandBase, executionLink?: dg.restfulApi.Link): ng.IPromise<any> {

            if (executionLink == null) {
                executionLink = <dg.restfulApi.Link>command.dgMeta.links[command.dgMeta.id + '_invoke'];
            }

            let commandData = dgUtils.ObjectHelperService.mergeDeep({}, command);
            this.fixCommand(commandData);
            return this.restfullApiClientService.post(executionLink.href, commandData);
        }



        private fixCommand(commandData: any) {

            for (let prop in commandData) {
                if ('dgMeta' === prop || commandData[prop] == null) {
                    commandData[prop] = undefined;
                }
                else if (commandData[prop] instanceof Date) {
                    commandData[prop] = new Date(commandData[prop].getTime() - (commandData[prop].getTimezoneOffset() * 60000)).toISOString();
                }

            }
        }

        private static adjustPropertyValues(domainObject: dg.domain.IDomainObject) {
            for (let prop in domainObject.dgMeta.properties) {
                let propMeta = domainObject.dgMeta.properties[prop];
                if (propMeta) {
                    if (!angular.isDefined(domainObject[prop])) {
                        domainObject[prop] = null;
                    } else if (domainObject[prop]) {
                        if (propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.Date
                            || propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.DateTime) {
                            domainObject[prop] = new Date(domainObject[prop]);
                        } else if (propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.DateRange
                            || propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.MonthRange) {
                            domainObject[prop] = {
                                //type: dg.domain.m
                                min: new Date(domainObject[prop].min),
                                max: new Date(domainObject[prop].max)
                            };
                        } else if (propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.Period) {
                            domainObject[prop] = <dg.domain.model.Period>{
                                //type: dg.domain.m
                                type: domainObject[prop].type,
                                value: domainObject[prop].value
                            };
                        }
                    }
                }
            }
        }




        public getQueryParams(query: dg.domain.queries.IQueryAction) {
            let queryParams: any = {};

            if (query) {
                for (let propName in query.dgMeta.properties) {
                    var prop = <dg.restfulApi.DomainObjectPropertyMetadata>query.dgMeta.properties[propName];

                    if (prop && !prop.readOnly && query[propName]) {
                        if (prop.propertyType == 'Reference') {

                            let arr = angular.isArray(query[propName]) ? query[propName] : [query[propName]];
                            let queryParamName = propName + '.id';
                            queryParams[queryParamName] = [];
                            arr.forEach(item => {
                                queryParams[queryParamName].push(item.id);
                            });
                            //} else if (prop.dataType == DG_DATA_TYPES.period) {
                            //    //convertToServer

                            //    this.addValueParams(query[propName], propName, queryParams);
                        } else {
                            this.addValueParams(query[propName], propName, queryParams);
                        }

                        if (prop.dataType == dg.restfulApi.DG_DATA_TYPES.Date) {
                            queryParams[propName] = this.dateToTimezoneLessDateISO(query[propName]);
                        }
                        else if (prop.dataType == dg.restfulApi.DG_DATA_TYPES.DateTime) {
                            queryParams[propName] = query[propName].toISOString()
                        }
                        else if (prop.dataType == dg.restfulApi.DG_DATA_TYPES.DateRange || prop.dataType == dg.restfulApi.DG_DATA_TYPES.MonthRange) {

                            queryParams[propName + '.min'] = this.dateToTimezoneLessDateISO(query[propName].min);
                            queryParams[propName + '.max'] = this.dateToTimezoneLessDateISO(query[propName].max);
                        }

                        //if (prop.dataType == dg.restfulApi.DG_DATA_TYPES.period && query[propName] && !isNaN(query[propName].type)) {
                        //    queryParams[`${propName}.type`] = dg.domain.model.PeriodType[query[propName].type];
                        //}
                    }
                }

                let sortCriteria: dg.domain.queries.SortCriterion[] = query['sortCriteria'];
                if (sortCriteria && sortCriteria[0] && sortCriteria[0].property) {
                    queryParams.sortCriteria = [];
                    angular.forEach(sortCriteria, item => {
                        queryParams.sortCriteria.push(item.property + ':' + item.direction);
                    });
                }
            }

            return queryParams;
        }

        private dateToTimezoneLessDateISO(date: Date) {
            //let dateFormat = this.dateService.getFormat(dg.restfulApi.DG_DATA_TYPES.date);
            let isoDateFormat = "yyyy-MM-dd";
            let str = this.$filter('date')(date, isoDateFormat);
            return str;
        }

        private getObjectParams(obj, parentKey) {
            let flatParams: any = {};
            for (var key in obj) {
                var value = obj[key];
                var newKey = parentKey ? parentKey + "." + key : key;  // joined key with dot
                this.addValueParams(value, newKey, flatParams)
            }

            return flatParams;
        }

        private addValueParams(value, currentKey, currentParams: any) {
            if (value) {
                if (value instanceof Object && !(value instanceof Date)) {
                    let childObjectParams = this.getObjectParams(value, currentKey);
                    currentParams = dgUtils.ObjectHelperService.mergeDeep(currentParams, childObjectParams);  // it's a nested object, so do it again
                } else {
                    currentParams[currentKey] = value;  // it's not an object, so set the property
                }
            }
        }
    }


    angular.module('dg.actions')
        .service('actionService', ActionService);
}